(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const root = qs('[data-gl-generator]');
  if (!root) return;
  const mode = new URLSearchParams(location.search).get('mode');
  const models = {
    'legends-were-born': { title: 'Legends Were Born', number: 'CRÉATION 001 · ANNÉE PERSONNALISABLE', heading: 'LEGENDS WERE BORN', lead: 'Choisis l’année de naissance. Elle prend automatiquement sa place au cœur du visuel.', design: 'gl-legends-sans-annee.png', font: 'Cowboy Outlaw', yearColour: '#ffffff', printFontSize: 325, printYearY: .518, variantKey: 'variantLegends' },
    'une-vraie-legende': { title: 'Une vraie légende', number: 'CRÉATION 002 · ANNÉE PERSONNALISABLE', heading: 'UNE VRAIE LÉGENDE', lead: 'Un modèle vintage en français pour célébrer une année mémorable.', design: 'gl-vraie-legende-sans-annee.png', font: 'Rye', yearColour: '#e8d5b3', printFontSize: 105, printYearY: .452, variantKey: 'variantVraie' },
    'les-legendes-sont-nees': { title: 'Les légendes sont nées', number: 'CRÉATION 003 · ANNÉE PERSONNALISABLE', heading: 'LES LÉGENDES SONT NÉES', lead: 'Une création rétro entièrement en français pour célébrer ta propre légende.', design: 'gl-legendes-nees-sans-annee.png', font: 'Cowboy Outlaw', yearColour: '#ffffff', printFontSize: 187, printYearY: .55, variantKey: 'variantNees' }
  };
  const model = models[mode];
  if (!model) return;

  const landing = qs('[data-gl-landing]');
  const builder = qs('.gl-builder', root);
  const design = qs('[data-gl-design]', root);
  const shirt = qs('[data-gl-shirt]', root);
  const year = qs('[data-gl-year]', root);
  const qty = qs('[data-gl-qty]', root);
  const submit = qs('[data-gl-submit]', root);
  const message = qs('[data-gl-message]', root);
  const products = JSON.parse(qs('[data-gl-products]', builder)?.textContent || '{}');
  const product = products[mode];
  const variantTables = JSON.parse(qs('[data-gl-variants]', builder)?.textContent || '{}');
  landing.hidden = true;
  root.hidden = false;
  root.dataset.glMode = mode;
  qs('[data-gl-generator-title]', root).textContent = model.title;
  qs('[data-gl-number]', root).textContent = model.number;
  qs('[data-gl-heading]', root).textContent = model.heading;
  qs('[data-gl-lead]', root).textContent = model.lead;

  const shirtAssets = { Noir: 'Black_Front.png', 'Antique Sapphire': 'Antique_Sapphire_Front.png', 'Antique Irish Green': 'Antique_Irish_Green_Front.png', 'Antique Cherry Red': 'Antique_Cherry_Red_Front.png' };
  const colours = { Noir: '#171717', 'Antique Sapphire': '#0787a5', 'Antique Irish Green': '#00a45a', 'Antique Cherry Red': '#c8102e' };
  const collagePositions = {
    'legends-were-born': { x: 483, y: 407, w: 235, h: 289, yearX: 600, yearY: 557, size: 46 },
    'une-vraie-legende': { x: 456, y: 357, w: 269, h: 355, yearX: 591, yearY: 517, size: 31 },
    'les-legendes-sont-nees': { x: 453, y: 373, w: 276, h: 323, yearX: 591, yearY: 550, size: 54 }
  };
  let colour = 'Noir';
  let size = 'S';
  const normalise = value => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  const colourAliases = {
    Noir: ['noir', 'black'],
    'Antique Sapphire': ['antique sapphire'],
    'Antique Irish Green': ['antique irish green'],
    'Antique Cherry Red': ['antique cherry red']
  };
  const selectedVariantId = () => {
    const fallback = Number(builder.dataset[model.variantKey] || 0);
    const variants = variantTables[mode]?.length ? variantTables[mode] : product?.variants;
    if (!variants?.length) return fallback;
    const aliases = colourAliases[colour].map(normalise);
    const match = variants.find(variant => {
      const options = [...(variant.options || []), variant.option1, variant.option2, variant.option3, variant.title]
        .filter(Boolean).map(normalise);
      const titleParts = normalise(variant.title).split('/').map(normalise);
      const values = [...options, ...titleParts];
      return values.includes(normalise(size)) && values.some(option => aliases.includes(option));
    });
    return Number(match?.id || 0);
  };
  const assetUrl = name => shirt.src.replace(/[^/?]+(?:\?.*)?$/, name);
  design.crossOrigin = 'anonymous';
  shirt.crossOrigin = 'anonymous';
  design.src = assetUrl(model.design);

  const render = () => {
    year.value = Math.max(1900, Math.min(2026, Number(year.value) || 1971));
    qs('[data-gl-preview-year]', root).textContent = year.value;
    qs('[data-gl-preview-year]', root).style.color = model.yearColour;
    qs('[data-gl-year-label]', root).textContent = year.value;
    qs('[data-gl-colour-label]', root).textContent = colour;
    shirt.src = assetUrl(shirtAssets[colour]);
  };

  Object.entries(colours).forEach(([name, hex]) => {
    const button = document.createElement('button');
    button.type = 'button'; button.title = name; button.setAttribute('aria-label', name); button.style.background = hex;
    button.classList.toggle('is-active', name === colour);
    button.onclick = () => { colour = name; qs('[data-gl-colours]', root).querySelectorAll('button').forEach(x => x.classList.toggle('is-active', x === button)); render(); };
    qs('[data-gl-colours]', root).append(button);
  });
  ['S', 'M', 'L', 'XL'].forEach(name => {
    const button = document.createElement('button');
    button.type = 'button'; button.textContent = name; button.classList.toggle('is-active', name === size);
    button.onclick = () => { size = name; qs('[data-gl-sizes]', root).querySelectorAll('button').forEach(x => x.classList.toggle('is-active', x === button)); };
    qs('[data-gl-sizes]', root).append(button);
  });
  qs('[data-gl-year-minus]', root).onclick = () => { year.value = Number(year.value) - 1; render(); };
  qs('[data-gl-year-plus]', root).onclick = () => { year.value = Number(year.value) + 1; render(); };
  year.oninput = render;

  const loadImage = image => image.complete && image.naturalWidth ? Promise.resolve() : new Promise((ok, no) => { image.onload = ok; image.onerror = no; });
  const blob = (canvas, type, quality) => new Promise(ok => canvas.toBlob(ok, type, quality));
  const loadFont = px => document.fonts ? document.fonts.load(`400 ${px}px "${model.font}"`) : Promise.resolve();

  const createFinalPng = async () => {
    await loadImage(design);
    await loadFont(model.printFontSize);
    const canvas = document.createElement('canvas');
    canvas.width = design.naturalWidth; canvas.height = design.naturalHeight;
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(design, 0, 0, canvas.width, canvas.height);
    context.fillStyle = model.yearColour;
    context.textAlign = 'center'; context.textBaseline = 'middle';
    context.font = `400 ${model.printFontSize}px "${model.font}", serif`;
    context.fillText(String(year.value), canvas.width / 2, canvas.height * model.printYearY);
    return blob(canvas, 'image/png');
  };

  const createCollage = async creationId => {
    await Promise.all([loadImage(shirt), loadImage(design)]);
    const p = collagePositions[mode];
    await loadFont(p.size);
    const canvas = document.createElement('canvas'); canvas.width = 1200; canvas.height = 1200;
    const context = canvas.getContext('2d');
    context.fillStyle = '#e4d1bd'; context.fillRect(0, 0, 1200, 1200);
    context.fillStyle = '#111a43'; context.font = 'bold 42px Arial'; context.fillText(`APERÇU DE COMMANDE — ${creationId}`, 50, 70);
    context.font = 'bold 26px Arial'; context.fillText(`${model.title} · ${colour} · ${size} · Année ${year.value}`, 50, 110);
    context.drawImage(shirt, 255, 145, 690, 865); context.drawImage(design, p.x, p.y, p.w, p.h);
    context.fillStyle = model.yearColour; context.textAlign = 'center'; context.textBaseline = 'middle'; context.font = `400 ${p.size}px "${model.font}", serif`;
    context.fillText(String(year.value), p.yearX, p.yearY);
    return blob(canvas, 'image/jpeg', .92);
  };

  submit.onclick = async () => {
    message.textContent = '';
    const variantId = selectedVariantId();
    if (!variantId) {
      console.warn(`Variante Shopify introuvable : ${model.title} / ${colour} / ${size}`);
      message.textContent = `La combinaison ${colour}, taille ${size}, n’est pas disponible actuellement.`;
      return;
    }
    submit.disabled = true;
    const initial = submit.textContent;
    try {
      const creationId = `TT-GL${Math.random().toString(36).slice(2, 9).toUpperCase()}`;
      submit.textContent = 'PRÉPARATION DU PNG…';
      const [finalPng, preview] = await Promise.all([createFinalPng(), createCollage(creationId)]);
      const description = `${creationId} — ${model.title} — Année ${year.value} — ${colour} — Taille ${size} — Quantité ${qty.value} — Devant seulement.`;
      const sheet = `FICHE DE PRODUCTION — TIENS-TOI.COM\n\nNuméro : ${creationId}\nCollection : Générations Légendaires\nModèle : ${model.title}\nAnnée : ${year.value}\nPolice : ${model.font}\nCouleur : ${colour}\nTaille : ${size}\nQuantité : ${qty.value}\nImpression : Devant seulement\n\nLe PNG transparent joint contient le visuel et l’année fusionnés; il est prêt pour l’impression.\n`;
      const body = new FormData();
      body.append('creationId', creationId); body.append('colour', colour); body.append('size', size); body.append('audience', 'Adulte');
      body.append('printing', 'Devant seulement'); body.append('quantity', qty.value); body.append('side', 'Devant seulement');
      body.append('description', description); body.append('orderDescription', description); body.append('frontText', String(year.value)); body.append('backText', 'Aucun texte');
      body.append('frontFont', model.font); body.append('backFont', 'Non indiquée'); body.append('pageUrl', location.href);
      body.append('frontPng', finalPng, `${creationId}-${mode}-${year.value}-IMPRESSION.png`);
      body.append('orderPreview', preview, `${creationId}-apercu-commande.jpg`);
      body.append('frontSheet', new Blob([sheet], { type: 'text/plain;charset=utf-8' }), `${creationId}-fiche-production.txt`);
      submit.textContent = 'ENVOI DE LA CRÉATION…';
      const sent = await fetch(builder.dataset.orderApi, { method: 'POST', body });
      const sentResult = await sent.json().catch(() => ({}));
      if (!sent.ok || !sentResult.ok) throw new Error(sentResult.error || 'Le courriel de production n’a pas pu être envoyé.');
      submit.textContent = 'AJOUT AU PANIER…';
      const properties = { '_Numéro de création': creationId, '_Collection': 'Générations Légendaires', '_Modèle': model.title, '_Année personnalisée': String(year.value), '_Police de l’année': model.font, '_Couleur': colour, '_Taille': size, '_Impression': 'Devant seulement', '_PNG final': `${creationId}-${mode}-${year.value}-IMPRESSION.png envoyé par AJAX`, '_Collage de commande': `${creationId}-apercu-commande.jpg envoyé par AJAX` };
      const cart = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: Math.max(1, Number(qty.value) || 1), properties }] }) });
      const cartResult = await cart.json().catch(() => ({}));
      if (!cart.ok) throw new Error(cartResult.description || cartResult.message || 'Ajout au panier impossible.');
      location.assign(window.routes?.cart_url || '/cart');
    } catch (error) { message.textContent = error.message; submit.disabled = false; submit.textContent = initial; }
  };
  render();
})();
